module.exports = __webpack_public_path__ + "static/media/ic_filter.e7604e7f.svg";